// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

ion-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  text-align: center;
}
ion-empty-state ion-icon {
  font-size: 4rem;
  color: var(--ion-color-medium);
}

ion-header {
  background: transparent;
}
ion-header ion-toolbar {
  --background: transparent;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 48px 16px;
  text-align: center;
}
.empty-state mat-icon {
  font-size: 4rem;
  width: 4rem;
  height: 4rem;
  color: var(--ion-color-medium);
}
.empty-state ion-icon {
  font-size: 64px;
  opacity: 0.8;
}
.empty-state h3 {
  margin: 16px 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: var(--ion-color-dark);
}
.empty-state p {
  margin: 0 0 24px;
  color: var(--ion-color-medium);
  font-size: 16px;
}

ion-skeleton-text {
  margin: 8px 0;
  border-radius: 4px;
}
ion-skeleton-text:first-child {
  margin-top: 16px;
}

ion-item-divider {
  --background: transparent;
  --padding-start: 0;
  border-bottom: 1px solid var(--ion-color-light);
}
ion-item-divider ion-label h2 {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--ion-color-medium);
}

mat-form-field {
  width: 100%;
}

.contact-item {
  --padding-start: 0;
}
.contact-item ion-avatar {
  width: 40px;
  height: 40px;
}
.contact-item ion-label h2 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}
.contact-item ion-label p {
  font-size: 14px;
  color: var(--ion-color-medium);
}
.contact-item ion-label p ion-icon {
  font-size: 14px;
  margin-right: 4px;
  vertical-align: middle;
}
.contact-item ion-toggle {
  --handle-width: 20px;
  --handle-height: 20px;
}

ion-fab-button {
  --box-shadow: 0 4px 16px rgba(var(--ion-color-primary-rgb), 0.2);
}

.loading-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/network/network.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,8BAAA;AACJ;;AAGA;EACE,uBAAA;AAAF;AAEE;EACE,yBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AADJ;AAIE;EACE,eAAA;EACA,YAAA;AAFJ;AAKE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAHJ;AAME;EACE,gBAAA;EACA,8BAAA;EACA,eAAA;AAJJ;;AAQA;EACE,aAAA;EACA,kBAAA;AALF;AAOE;EACE,gBAAA;AALJ;;AASA;EACE,yBAAA;EACA,kBAAA;EACA,+CAAA;AANF;AAQE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;AANJ;;AAUA;EACE,WAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;AAPJ;AAWI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AATN;AAYI;EACE,eAAA;EACA,8BAAA;AAVN;AAYM;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;AAVR;AAeE;EACE,oBAAA;EACA,qBAAA;AAbJ;;AAiBA;EACE,gEAAA;AAdF;;AAiBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAdF;AACA,4mIAA4mI","sourcesContent":[":host {\n  display: block;\n}\n\nion-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 2rem;\n  text-align: center;\n\n  ion-icon {\n    font-size: 4rem;\n    color: var(--ion-color-medium);\n  }\n}\n\nion-header {\n  background: transparent;\n\n  ion-toolbar {\n    --background: transparent;\n  }\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 48px 16px;\n  text-align: center;\n\n  mat-icon {\n    font-size: 4rem;\n    width: 4rem;\n    height: 4rem;\n    color: var(--ion-color-medium);\n  }\n\n  ion-icon {\n    font-size: 64px;\n    opacity: 0.8;\n  }\n\n  h3 {\n    margin: 16px 0 8px;\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--ion-color-dark);\n  }\n\n  p {\n    margin: 0 0 24px;\n    color: var(--ion-color-medium);\n    font-size: 16px;\n  }\n}\n\nion-skeleton-text {\n  margin: 8px 0;\n  border-radius: 4px;\n  \n  &:first-child {\n    margin-top: 16px;\n  }\n}\n\nion-item-divider {\n  --background: transparent;\n  --padding-start: 0;\n  border-bottom: 1px solid var(--ion-color-light);\n\n  ion-label h2 {\n    font-size: 14px;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: var(--ion-color-medium);\n  }\n}\n\nmat-form-field {\n  width: 100%;\n}\n\n.contact-item {\n  --padding-start: 0;\n  \n  ion-avatar {\n    width: 40px;\n    height: 40px;\n  }\n\n  ion-label {\n    h2 {\n      font-size: 16px;\n      font-weight: 500;\n      margin-bottom: 4px;\n    }\n\n    p {\n      font-size: 14px;\n      color: var(--ion-color-medium);\n      \n      ion-icon {\n        font-size: 14px;\n        margin-right: 4px;\n        vertical-align: middle;\n      }\n    }\n  }\n\n  ion-toggle {\n    --handle-width: 20px;\n    --handle-height: 20px;\n  }\n}\n\nion-fab-button {\n  --box-shadow: 0 4px 16px rgba(var(--ion-color-primary-rgb), 0.2);\n}\n\n.loading-spinner {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
